module.exports = __webpack_public_path__ + "img/SMT_22_Ms_Karen_Lee_Hwei_Mien.5621c3ea.jpg";